
(function($) {
    $.History = function() {
        this._component_name = "history"; 
        this._location_history = [];  
        this._min_segments = 10;
        this._max_history = 100;
        this._enabled = true;
        this._on_update_viewport_bind = this._on_update_viewport.bind(this);
    };

    $.Component.create($.History, {
        _init: function(options) {
            this._options = options || {};
            this._buttons_container = this._options.buttons_container || '#buttons-overlay > .buttons-container';

            if (typeof(this._buttons_container) === 'string') {
                this._buttons_container = document.querySelector(this._buttons_container);
            }
            this._btn_location_history = this._options.btn_enable_history || 'button.btn-location-history';
            if (typeof(this._btn_location_history) === 'string') {
                this._btn_location_history = document.querySelector(this._btn_location_history);
            }

            if (typeof(this._options.enabled) !== "undefined") {
                this._enabled = this._options.enabled;
            }
            if (this._enabled) {
                this.parent._on(this.parent._events.finished_tracking, this._save.bind(this));
    
                // select first immediate children of #buttons-overlay as a container 
                if(this._buttons_container && this._btn_location_history) {
                    // var _btn_location_history = document.createElement('button');
                    // var text = '移動履歴';
                    // _btn_location_history.dataset.langkey = text;
                    // _btn_location_history.innerText = text;
                    // _btn_location_history.classList.add('btn_style_1');
                    // this._buttons_container.prepend(_btn_location_history); 
                    
                    this._btn_location_history.addEventListener(
                        ABDOUtil.getClickHandler(this._btn_location_history), 
                        this._toggle.bind(this));
                }
            }
        }, 

        _toggle: function() { 
            if (this._enabled) {
                this._hide();
            }
            else {
                this._show();
            }
        },

        _save: function(event) {
            var location = event.detail.location;
            var position = event.detail.position;

            if (this._location_history.length > 0) {
                var eps = 2.2204460492503130808472633361816E-16;
                var last_point_location = this._location_history[this._location_history.length - 1].location;
                var distance_to_last_point = location.distanceTo(last_point_location);
                if (distance_to_last_point < eps) {
                    return;
                }
            }
    
            if (this._location_history.length == this._max_history) {
                this._location_history.shift(); // remove first element
            }
    
            this._location_history.push({
                location: location,
                position: position
            });
        },

        _clear: function() {
            this._location_history = [];
        },

        _get_color: function(index, max) {
            if (typeof(max) === 'undefined') {
                max = this._location_history.length - 1;
            }
            var reference = index / max;
    
            var colors = [
                {ref: 0.0,  r:0,   g:0,   b:255, a: 0.0},
                {ref: 0.25, r:0,   g:255, b:0, a: 0.6},
                {ref: 0.75, r:255, g:255, b:0, a: 0.8},
                {ref: 1.0,  r:255, g:0,   b:0, a: 1.0},
            ];
    
            var i, colors_length = colors.length;
            for (i = 1; i < colors_length; i++) {
                var color = colors[i];
                var prev_color = colors[i-1];
                if (reference >= prev_color.ref && reference <= color.ref) {
                    var ref_diff = (reference - prev_color.ref) / (color.ref - prev_color.ref);
                    var output = {
                        ref: reference,
                        r: (color.r - prev_color.r)*ref_diff + prev_color.r, 
                        g: (color.g - prev_color.g)*ref_diff + prev_color.g, 
                        b: (color.b - prev_color.b)*ref_diff + prev_color.b,
                        a: (color.a - prev_color.a)*ref_diff + prev_color.a,
                    }; 
                    return output;
                } 
            }
        },
        
        _draw: function(evt) {
            if (this._location_history.length < this._min_segments) {
                this._draw_interpolated(evt);
                return;
            }
     
            var location_history_len = this._location_history.length, i;
            for (i = 0; i < location_history_len; ++i) {
                var history_item = this._location_history[i]; 
                if (i > 0) {
                    var prev_history_item = this._location_history[i-1]; 
                    var color = this._get_color(i);
    
                    this._draw_line(prev_history_item.location, history_item.location, color); 
                }
            }
        },

        _get_hex_color: function(color, padding) {
            var ret = Number(Math.round(color)).toString(16);
            padding = padding || 0;
            var padding_length = padding - ret.length;
            var padding_string = "";
            for (var i = 0; i < padding_length; i++) {
                padding_string = padding_string + "0";
            }
            
            return padding_string + ret;
        },

        _draw_line: function(location_a, location_b, color) {
            var viewer = ABDOUtil.getViewer();
            if (viewer) {
                var ctx = viewer.drawer.context;
    
                var location_canvas_a = viewer.viewport.pixelFromPoint(location_a);
                var location_canvas_b = viewer.viewport.pixelFromPoint(location_b);
        
                var prev_strokestyle = ctx.strokeStyle;
                ctx.beginPath();
                ctx.lineWidth = 5;
        
                // ブラウザーが古くてAlphaがサポートされていないかもしれませんので、RGBにします
                if (typeof(ctx.setStrokeColor) !== 'undefined' || ABDOUtil.isIE) { 
                    var color_string = '#' + this._get_hex_color(color.r, 2) + this._get_hex_color(color.g, 2) + this._get_hex_color(color.b, 2);
                
                    ctx.strokeStyle = color_string;
                }
                else {
                    ctx.strokeStyle = 'rgba(' + color.r + ',' + color.g + ',' + color.b + ',' + color.a + ')';
                }  
        
                ctx.moveTo(location_canvas_a.x, location_canvas_a.y);
                ctx.lineTo(location_canvas_b.x, location_canvas_b.y);
                ctx.stroke();
        
                // ラインのスタイルを回復
                ctx.strokeStyle = prev_strokestyle;
            }
        },

        _draw_interpolated: function(evt) { 
            var line_segments = this._location_history.length - 1;
            var subsegments_per_line = Math.floor(this._min_segments / line_segments);
            var total_segments = subsegments_per_line * line_segments;
    
            var segment_index, subsegment_index;

            for (segment_index = 0; segment_index < line_segments; segment_index++) {
                var history_item_a = this._location_history[segment_index];
                var history_item_b = this._location_history[segment_index+1];
     
                var x_step = (history_item_b.location.x - history_item_a.location.x) / subsegments_per_line;
                var y_step = (history_item_b.location.y - history_item_a.location.y) / subsegments_per_line; 
    
                for (subsegment_index = 0; subsegment_index < subsegments_per_line; subsegment_index++) {
                    var x_delta_a = (subsegment_index)*x_step;
                    var y_delta_a = (subsegment_index)*y_step;
                    var x_delta_b = (subsegment_index+1)*x_step;
                    var y_delta_b = (subsegment_index+1)*y_step;
    
                    var pt_a = new OpenSeadragon.Point(history_item_a.location.x + x_delta_a, history_item_a.location.y + y_delta_a);
                    var pt_b = new OpenSeadragon.Point(history_item_a.location.x + x_delta_b, history_item_a.location.y + y_delta_b);
    
                    var current_index = (segment_index * subsegments_per_line) + subsegment_index + 1;
                    var color = this._get_color(current_index, total_segments);
    
                    this._draw_line(pt_a, pt_b, color);
                }
            }
        },

        _on_update_viewport: function(evt) { 
            this._draw(evt);
        },

        _refresh_viewer: function() {
            var viewer = ABDOUtil.getViewer();
            if (viewer) {
                viewer.world.draw();
                viewer.raiseEvent('update-viewport', viewer);
            }
        },

        _show: function() {
            var viewer = ABDOUtil.getViewer();
            if (viewer) {
                viewer.addHandler('update-viewport', this._on_update_viewport_bind);
                this._refresh_viewer();
                this._enabled = true;
            }
        },

        _hide: function() {
            var viewer = ABDOUtil.getViewer();
            if (viewer) {
                viewer.removeHandler('update-viewport', this._on_update_viewport_bind);
                this._refresh_viewer();
                this._enabled = false;
            }
        },

    }, $.Tracker);
         
})(ABDOMap);
 